import Component from '../inherited/Component'
import Helpers from '../lib/Helpers'

export default class Product extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._options = {
      ...{
        historyState: true
      }, ...this._options
    }
    this._imageSliders = this._elem.querySelectorAll('.product__media-list .slider__slide[data-image-alt-color]');
    this._swatches = this._elem.querySelectorAll('.fieldset--color input');
    this._imageSlide = this._elem.querySelector('.product__media-list');
  }

  mount() {
    if (this._product === null) {
      return false
    }
    document.querySelector('.product-option-type-size').append(document.querySelector('.product-popup-modal__opener'));
    document.querySelector('.product-popup-modal__opener').classList.remove('hide');
    this._hideVariantImage();
  }

  _formatMoney(price) {
    return Helpers.formatMoney(price, this._ctx.getState())
  }

  _changeCombineWith(colorSelected) {
    const cardProducts =  this._elem.querySelectorAll('.card-product');
    cardProducts.forEach(card => {
      const productToJson = JSON.parse(card.previousElementSibling.innerHTML);
      const productColor = productToJson.variants.find(variant => variant.color.toUpperCase() === colorSelected);
      if (productColor) {
        const cardImg = card.querySelector('.card__media img');
        const cardLinks = card.querySelectorAll('a');
        cardLinks.forEach(cardLink => {
          cardLink.href = cardLink.href + '&variant=' + productColor.id;
        });
        cardImg.src = productColor.featured_image;
        cardImg.srcset = productColor.featured_image;
      }
    });
  }

  _updateImageSize(activeImages) {
    const activeImagesLength = activeImages.length;
      if (activeImagesLength < 6) {
        switch (activeImagesLength) {
          case 2:
            activeImages.each(image => {
              image.addClass('full-image');
            });
            break;
          case 3:
            activeImages[0].classList.add('full-image');
            break;
          case 5:
            activeImages[2].classList.add('full-image');
            break;
          default:
            break;
        }
      } else {
        activeImages[2].classList.add('full-image');
      }
  }
  _hideVariantImage() {
    const imageSliders = [...this._imageSliders];
    const activeImages = document.querySelectorAll('.product__media-list .product__media-item:not(.hide)');
    this._updateImageSize(activeImages);
    this._imageSlide.classList.remove('hidden');
    this._swatches.forEach(element => {
      element.addEventListener('change', (event) => {
        const swatchValue = event.target.value.toUpperCase();
        const imagesSelected = [...imageSliders.filter(slider => slider.getAttribute('data-image-alt-color').toUpperCase() === swatchValue)];
        this._changeCombineWith(swatchValue);
        imageSliders.forEach(slider => {
          slider.classList.add('hide-i');
        });
        imagesSelected.forEach(function (slider, index) {
          slider.classList.remove('hide-i');
        });
        const images = document.querySelectorAll('.product__media-list .product__media-item.full-image');
        const activeImages = $('.product__media-list .product__media-item:visible');
        images.forEach(image => {
          image.classList.remove('full-image');
        });
        this._updateImageSize(activeImages);
      });
    });
  }

}